import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import isoWeek from 'dayjs/plugin/isoWeek';
import minMax from 'dayjs/plugin/minMax';

// Shared dayjs instance with the plugins the app relies on:
//  - customParseFormat → dayjs(str, 'FORMAT') strict-format parsing
//  - relativeTime      → .fromNow()
//  - quarterOfYear     → 'quarter' unit in add/subtract/startOf/endOf
//  - isoWeek           → 'isoWeek' unit in startOf/endOf
//  - minMax            → dayjs.min() / dayjs.max()
dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);
dayjs.extend(quarterOfYear);
dayjs.extend(isoWeek);
dayjs.extend(minMax);

export default dayjs;
